







































import { PropType } from 'vue';
import { mapActions } from 'vuex';

import { ContractStateEnum, IContract } from '@/models';
import { ISystemError } from '@/models/error/error.types';

import { setErrorFromAxiosError } from '@/utils/helpers';

import auth from '@/mixins/auth';
import mixins from '@/utils/mixins';

import ConfirmationDialog from '@/components/common/ConfirmationDialog.vue';

export default mixins(auth).extend({
  name: 'ContractTerminateStateButton',

  components: {
    ConfirmationDialog
  },

  props: {
    contract: {
      type: Object as PropType<IContract>
    }
  },

  data() {
    return {
      error: null as ISystemError | null,

      isStateTransitioning: false,
      isDialogActive: false
    };
  },

  methods: {
    ...mapActions({
      updateContractState: 'contract/updateContractState'
    }),

    clearErrors() {
      this.error = null;
    },

    terminateContract() {
      this.clearErrors();
      this.isStateTransitioning = true;
      this.updateContractState({
        contractId: this.contract.id,
        state: ContractStateEnum.Terminated
      })
        .then(() => {
          this.isDialogActive = false;
        })
        .catch(error => {
          this.error = setErrorFromAxiosError(error);
        })
        .finally(() => {
          this.isStateTransitioning = false;
        });
    }
  }
});
